import { Maybe } from '@passionware/monads';
import { myEnterpriseFeatureFlagService } from 'v5/services/io/EnterpriseFeatureFlagService/EnterpriseFeatureFlagService.connected';
import { createServerFeatureFlagSource } from './serverFeatureFlagSource';

export const myServerFeatureFlagSource = createServerFeatureFlagSource({
  enterpriseFeatureFlagService: myEnterpriseFeatureFlagService
});
